const BookingModal = () => {
    document.addEventListener('click', function (event) {
        const button = event.target.closest('.js-book-assessment');

        if (!button) {
            return;
        }

        const modal = document.getElementById('shared-booking-modal');

        if (!modal) {
            return;
        }

        const titleElement = modal.querySelector('.js-booking-title');
        const priceElement = modal.querySelector('.js-booking-price');
        const linkElement = modal.querySelector('.js-booking-link');

        if (titleElement) {
            titleElement.textContent = button.dataset.title || '';
        }

        if (priceElement) {
            priceElement.textContent = button.dataset.price || '';
        }

        if (linkElement) {
            linkElement.href = button.dataset.link || '#';
        }
        
        const assessmentTypeField = modal.querySelector('[name="input_11"]');
        const clinicField = modal.querySelector('[name="input_12"]');

        if (assessmentTypeField) {
            assessmentTypeField.value = button.dataset.assessmentType || '';
        }

        if (clinicField) {
            clinicField.value = button.dataset.clinic || '';
            clinicField.dispatchEvent(
                new Event('change', { bubbles: true })
            );
        }
    }, true);
};

export default BookingModal;